export default {
    companies: "api/company/",
    subID:(id) => `api/subscriber-groups/${id}/`,
    invite:"api/invite-user/"
  }